import styled from 'styled-components';
import { Button } from '@sainsburys-tech/bolt';
var DidYouMeanContainer = styled.div.withConfig({
  displayName: "DidYouMeanstyles__DidYouMeanContainer",
  componentId: "sc-8uwlht-0"
})(["padding:5px 15px 0;overflow:auto;max-height:490px;"]);
var DidYouMeanTitle = styled.h3.withConfig({
  displayName: "DidYouMeanstyles__DidYouMeanTitle",
  componentId: "sc-8uwlht-1"
})(["margin:15px 0 5px;letter-spacing:0;font-size:", ";font-weight:", ";"], function (props) {
  return props.theme.font.size['display-2'];
}, function (props) {
  return props.theme.font.weight.bold;
});
var DidYouMeanResults = styled.ol.withConfig({
  displayName: "DidYouMeanstyles__DidYouMeanResults",
  componentId: "sc-8uwlht-2"
})(["margin:0 0 50px;"]);
var DidYouMeanResult = styled.li.withConfig({
  displayName: "DidYouMeanstyles__DidYouMeanResult",
  componentId: "sc-8uwlht-3"
})(["margin:0;border-top:", ";"], function (props) {
  return props.index === 0 ? 0 : "1px solid ".concat(props.theme.color.monochrome.light);
});
var DidYouMeanLocation = styled(Button).withConfig({
  displayName: "DidYouMeanstyles__DidYouMeanLocation",
  componentId: "sc-8uwlht-4"
})(["color:", ";padding:15px 0;border:none;&:hover{color:", ";}"], function (props) {
  return props.theme.color.palette['brand-1'];
}, function (props) {
  return props.theme.color.monochrome.base;
});
export { DidYouMeanContainer, DidYouMeanTitle, DidYouMeanResults, DidYouMeanResult, DidYouMeanLocation };